import { render } from "./DashboardMainPage.vue?vue&type=template&id=6437b2ad&scoped=true"
import script from "./DashboardMainPage.vue?vue&type=script&lang=js"
export * from "./DashboardMainPage.vue?vue&type=script&lang=js"

import "./DashboardMainPage.vue?vue&type=style&index=0&id=6437b2ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6437b2ad"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader});
